import { makeStyles, Theme } from '@material-ui/core/styles'

const stylesCategories = makeStyles<
  Theme,
  { colors: any; matches: boolean; matchesMobile: boolean }
>((theme) => ({
  main: {
    minHeight: '20vh',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  headerCategories: ({ colors }) => ({
    backgroundColor: colors.accentColor,
    width: '100%',
    padding: '16px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  listCategories: {
    maxWidth: '1320px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    margin: '56px 0px 72px 0px',
    overflowX: 'hidden',
  },
  card: ({ colors }) => ({
    height: 175,
    width: 175,
    borderRadius: '50%',
    color: colors.accentColor,
    fontSize: theme.typography.pxToRem(18),
    backgroundColor: colors.accentColorBackground,
  }),
  textTitle: ({ colors }) => ({
    position: 'relative',
    cursor: 'pointer',
    marginRight: 42,
    color: colors.textBody,
    fontWeight: 700,
  }),
  textTitleInitial: ({ colors }) => ({
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 800,
    color: colors.textAccentColor,
    textTransform: 'uppercase',
  }),
  textSubTitle: ({ colors }) => ({
    position: 'relative',
    fontFamily: 'Roboto',
    paddingBottom: 10,
    color: colors.textBody,
    letterSpacing: '0.1px',
    lineHeight: '24px',
    fontWeight: 400,
    fontSize: 18,
    opacity: 0.5,
  }),
  iconNavigate: ({ colors }) => ({
    color: colors.accentColor,
    border: `1px solid ${colors.accentColor}`,
    '&:hover': {
      color: colors.accentColor,
      background: '#fff',
      transition: 'all 0.2s ease',
    },
  }),
  IconNavite: ({ colors }) => ({
    color: colors.accentColor,
    width: 32,
    height: 32,
    background: '#fff',
    padding: 0,
    '&:hover': {
      backgroundColor: colors.cardAccentColor,
      color: '#fff',
    },
  }),
  icon: {
    width: '100%',
    height: '100%',
  },
  slider: {
    display: 'flex',
    alignItems: 'center',
    '& .slick-list': {
      margin: 0,
    },
    '& .slick-slide': {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 20,
    },
  },
  button: ({ colors }) => ({
    width: 'max-content',
    alignSelf: 'center',
    color: colors.accentColor,
    backgroundColor: colors.colorBackgroundSecundary,
    borderRadius: 50,
    '&:hover': {
      backgroundColor: colors.colorBackgroundSecundary,
    },
  }),
  buttonText: {
    marginRight: 8,
    marginLeft: 8,
    textTransform: 'uppercase',
    fontSize: 14,
    fontWeight: 500,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
  },
  cardImage: {
    width: 115,
    marginBottom: 14,
  },
  cardTitle: ({ colors }) => ({
    color: colors.accentColor,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  }),
  categoryIcon: {
    fontSize: 60,
    color: '#fff',
  },
  categoryTitle: {
    color: '#fff',
    fontSize: 14,
    marginTop: 20,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
}))

export default stylesCategories
